import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import { AiAssistantBanner, aiAssistantTexts } from "../models/aiAssistantModels";
import styles from "../AiAssistantPage.module.scss";

interface IAiBannerProps {
  banner: AiAssistantBanner;
  resetDateLabel: string;
  onNewConversation: () => void;
  onWriteToTeam: () => void;
}

/** Why the composer is off right now, with the way forward. */
export const AiBanner = ({ banner, resetDateLabel, onNewConversation, onWriteToTeam }: IAiBannerProps) => {
  if (banner === "budget") {
    return (
      <div className={styles.banner} role="status">
        <p className={styles.banner_text}>
          {aiAssistantTexts.budgetReachedPrefix} Ще се поднови на {resetDateLabel}. Дотогава екипът на Planny
          ще ви помогне с удоволствие.
        </p>
        <DefaultButton
          className={styles.banner_button}
          design="outline"
          width="auto"
          label={aiAssistantTexts.writeToTeam}
          onClick={onWriteToTeam}
        />
      </div>
    );
  }

  if (banner === "conversationFull") {
    return (
      <div className={styles.banner} role="status">
        <p className={styles.banner_text}>{aiAssistantTexts.conversationFull}</p>
        <DefaultButton
          className={styles.banner_button}
          design="outline"
          width="auto"
          label={aiAssistantTexts.newConversation}
          onClick={onNewConversation}
        />
      </div>
    );
  }

  return null;
};
